module.exports = __webpack_public_path__ + "img/20250218-01-02.c5150f65.png";